module.exports = __webpack_public_path__ + "img/cuco-otimo.0ddb56e4.svg";